( function( $ ) {

    $(document).ready( function() {
        // Page removes all this from the dom the reinserts it. Need to bind events to document instead of element
        
        // // Accordion Block
        // $(window).bind('load resize', function() {
        //     $('.accordion-body-wrapper').each(function() {
        //         let height = $(this).children('.accordion-body-inner').outerHeight() + 'px';
        //         $(this).css('--body-height', height);

        //     });
        // });


        // $(document).on('click', '.accordion-title', function() {
        //     console.log('Toggle accordion');
        //     if($(this).parent().hasClass('open')) {
        //         $(this).parent().removeClass('open');
        //     } else {
        //         $('.accordion-item').removeClass('open');
        //         $(this).parent().addClass('open');
        //     }
        // });

    } );

} )( jQuery );
